"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cssClassesHelper = require("../../../helpers/cssClassesHelper");
var _APLabelWithText = _interopRequireDefault(require("../APLabelWithText"));
require("./SidePaneDetails.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var bemClasses = (0, _cssClassesHelper.getBEMClasses)('sidepane-details');
var SidePaneDetailsComponent = function SidePaneDetailsComponent(props) {
  var title = props.title,
    items = props.items,
    info = props.info,
    infoHeader = props.infoHeader,
    classModifiers = props.classModifiers,
    link = props.link;
  var _useTranslation = (0, _reactI18next.useTranslation)('core'),
    t = _useTranslation.t;
  var isHtmlString = typeof info === 'string';
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("header", {
    className: bemClasses('header', classModifiers)
  }, title), /*#__PURE__*/_react["default"].createElement("section", {
    className: bemClasses('body')
  }, items && items.map(function (_ref) {
    var label = _ref.label,
      text = _ref.text;
    return /*#__PURE__*/_react["default"].createElement(_APLabelWithText["default"], {
      key: label,
      label: label,
      text: text,
      customClass: bemClasses()
    });
  })), items === undefined || items.length === 0 ? /*#__PURE__*/_react["default"].createElement("div", {
    className: bemClasses('divider')
  }) : null, /*#__PURE__*/_react["default"].createElement("section", {
    className: bemClasses('information', classModifiers)
  }, infoHeader && /*#__PURE__*/_react["default"].createElement("div", {
    className: bemClasses('information-header')
  }, infoHeader), info && (isHtmlString ? /*#__PURE__*/_react["default"].createElement("div", {
    dangerouslySetInnerHTML: {
      __html: info
    }
  }) : info.map(function (item, index) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: bemClasses('information-text', classModifiers),
      key: index
    }, item);
  })), (link === null || link === void 0 ? void 0 : link.text) && /*#__PURE__*/_react["default"].createElement("a", {
    href: link.url
  }, " ", t(link.text), " ")));
};
SidePaneDetailsComponent.defaultProps = {
  link: {
    text: '',
    url: ''
  }
};
SidePaneDetailsComponent.propTypes = {
  title: _propTypes["default"].string,
  items: _propTypes["default"].array,
  info: _propTypes["default"].oneOfType([_propTypes["default"].array, _propTypes["default"].string]),
  infoHeader: _propTypes["default"].string,
  link: _propTypes["default"].object
};
SidePaneDetailsComponent.getItem = function (label, text) {
  return {
    label: label,
    text: text
  };
};
var _default = exports["default"] = SidePaneDetailsComponent;